import React, { useState, useCallback, useEffect, useRef } from "react";
import privateAxios from "../../../../utils/axiosPrivate";
import {
  normalizeOrgType,
  sanitizeInput,
  showToast
} from "../../../../utils/utils";
import {
  countries,
  org_types,
  account_type
} from "../../../../utils/data/data";
import CountryinfoModal from "../../../../components/modals/CountryinfoModal";
import { SuccessfullModal } from "../../../../components/modals/SuccessfullModal";
import { useParams } from "react-router-dom";
import { FaLongArrowAltDown } from "react-icons/fa";
import { TbRefresh } from "react-icons/tb";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import {
  getUsersClientDetailsData,
  getUsersCountryInfoData,
  getUsersData,
  updateProfile
} from "../../../../redux/userManagementSlice";
import styles from "./../../../../assets/scss/custom.module.scss";
import {
  bankDetls,
  commonErrMsg,
  customerTab,
  EditReffPartner,
  Inputfieldvalidation,
  manualUpdate,
  tooltipContent,
  tooltips
} from "../../../../locales/en";
import {
  NUMBER_REGEX,
  PREVENT_BUTTON_CLICK,
  showToastType
} from "../../../../utils/constants/appConstants";
import { COUNTRY_CODE_AU } from "../../../../utils/constants/appConstants";
import {
  gethandleDownloadPDFURL,
  getIndustryCategoriesURL,
  getNZBNUserURL,
  getOrganizationNzbnURL,
  getPipedriveSyncURL
} from "../../../../utils/constants/apiEndPoints";
import { Tooltip as ReactTooltip } from "react-tooltip";
import ErrorBoundary from "../../../../components/error-boundary";
import ComponentViewFallback from "../../../../components/error-boundary/fallback/ComponentViewFallback";
import useUserMetaUpdater from "../../../../hooks/useUserMetaUpdater";
import { fetchIndustryTypeData } from "../../../../redux/clientDetailsTabSlice";
import { useToast } from "../../../../hooks/useToast";
import { usePrventBtnClick } from "../../../../hooks/usePrventBtnClick";
import CommonInput from "../../../../components/common/CommonInput";

const CustomerDetails = ({
  accSoftwareIsConnct,
  accSoftwareConct,
  onRefreshSoftware
}) => {
  const toast = useToast();
  const { id } = useParams();
  const [industryType, setIndustryType] = useState([]);
  const [industryCategory, setIndustryCategory] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const initialCombineData = {
    nzbn: "",
    abn: "",
    acn: "",
    organizationId: "",
    organisationType: "",
    organizationAge: "",
    organizationName: "",
    organizationStatus: "",
    accountType: "",
    tradingName: "",
    taxNumber: "",
    pricingIndustryId: "",
    industryDetails: "",
    industryClassification: "",
    primaryCountry: ""
  };
  const [combineData, setCombineData] = useState(initialCombineData);
  const [prevValues, setPrevValues] = useState(combineData);
  const initialCountryInformation = {
    accountingCountry: "",
    originCountry: ""
  };
  const [countryInformation, setCountryInformation] = useState(
    initialCountryInformation
  );

  const [addCountryMoadal, setAddCountryMoadal] = useState(false);
  const [accountMeta, setAccountMeta] = useState({});
  const [organisationType, setOrganisationType] = useState("");
  const [pricingIndustryId, setPricingIndustryId] = useState("");
  const [showDownload, setShowDownload] = useState(false);
  const [organizationID, setOrganizationID] = useState("");
  const [getNZBN, setgetNZBN] = useState("");
  const [showSelect, setShowSelect] = useState(false);
  const [showSelectData, setShowSelectData] = useState([]);
  const initialCustomerDetailsError = {
    organizationName: null,
    tradingName: null,
    acn: null
  };
  const [customerDetailsError, setCustomerDetailsError] = useState(
    initialCustomerDetailsError
  );

  const dispatch = useDispatch();
  const { isProcessing, isLocked, setIsProcessing } =
    usePrventBtnClick(PREVENT_BUTTON_CLICK);

  const [customerDetails, setCustomerDetails] = useState({});

  const { updateUserMeta } = useUserMetaUpdater({
    id,
    setAccountMeta,
    setPrevValues,
    successMessage: customerTab?.details.errMsg.item3
  });

  useEffect(() => {
    const fetchCustomerDetailsData = async () => {
      try {
        const response = await dispatch(
          getUsersClientDetailsData({ id })
        ).unwrap();
        setCustomerDetails(response.data.data);
      } catch {
        //handle error
      }
    };
    fetchCustomerDetailsData();
  }, [dispatch, id]);

  useEffect(() => {
    const fetchIndustryType = async () => {
      try {
        const response = await dispatch(fetchIndustryTypeData()).unwrap();
        setIndustryType(response?.data);
      } catch (error) {
        const errorMessages = error.response?.data?.errors || [
          commonErrMsg.item2
        ];
        toast.error(errorMessages[0]);
      }
    };
    fetchIndustryType();
  }, []);

  useEffect(() => {
    const fetchIndustryCategoryType = async () => {
      try {
        const response = await privateAxios.get(getIndustryCategoriesURL);
        setIndustryCategory(response.data.data);
      } catch (error) {
        const errorMessages = error.response?.data?.errors || [
          commonErrMsg.item2
        ];
        toast.error(errorMessages[0]);
      }
    };
    fetchIndustryCategoryType();
  }, []);

  // Country Information Details
  const countryInfoCalledRef = useRef(false);
  useEffect(() => {
    if (countryInfoCalledRef.current) return;
    countryInfoCalledRef.current = true;
    const fetchCountryInformation = async () => {
      try {
        const response = await dispatch(
          getUsersCountryInfoData({ id })
        ).unwrap();
        setCountryInformation(response.data.data);
      } catch {
        // handle catch here;
      }
    };
    fetchCountryInformation();
  }, [id]);

  const pipedriveSyncCalledRef = useRef(false);

  useEffect(() => {
    if (pipedriveSyncCalledRef.current) return;
    pipedriveSyncCalledRef.current = true;
    const syncPipedrive = async () => {
      try {
        await privateAxios.post(getPipedriveSyncURL(id, true));
      } catch {
        // handle catch here;
      }
    };
    if (id) {
      syncPipedrive();
    }
  }, [id]);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const toggleCountryAdd = () => {
    setAddCountryMoadal(!addCountryMoadal);
  };

  const [addSuccessfullModal, setAddSuccessfullModal] = useState(false);
  const toggleAddSuccessfullModal = () => {
    setAddSuccessfullModal(!addSuccessfullModal);
  };

  const handleRefreshSoftwareConnect = async () => {
    if (isLocked()) return;
    setIsProcessing(true);
    try {
      await onRefreshSoftware(true);
    } finally {
      setIsProcessing(false);
    }
  };

  const getOrganization = useCallback(async ({ value }) => {
    try {
      const response = await privateAxios.get(getOrganizationNzbnURL, {
        params: {
          organizationName: sanitizeInput(value),
          page: "0",
          size: "10"
        }
      });
      setShowSelectData(response.data.data);
    } catch {
      // handle catch here;
    }
  }, []);

  useEffect(() => {
    const businessDetails =
      customerDetails?.customerDetails?.businessDetails ?? initialCombineData;
    const apiOrgType = customerDetails?.customerDetails?.organisationType ?? "";
    const mappedOrgType = normalizeOrgType(apiOrgType);

    setCombineData(businessDetails);
    setPrevValues(businessDetails);

    setAccountMeta(customerDetails?.customerDetails ?? {});
    setOrganisationType(mappedOrgType);
    setPricingIndustryId(
      customerDetails?.customerDetails?.pricingIndustryId ?? ""
    );
    setOrganizationID(businessDetails.organizationId ?? "");
    setgetNZBN(businessDetails.nzbn ?? "");

    setShowDownload(Boolean(businessDetails.nzbn));
    localStorage.setItem(
      "userCountryCode",
      customerDetails?.customerDetails?.primaryCountry
    );
  }, [customerDetails]);

  const updateCombineData = (name, value) => {
    setCombineData((prev) => ({ ...prev, [name]: value }));
  };

  const updatePrevValue = (name, value) => {
    setPrevValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleCountryChange = async (event) => {
    const { name, value } = event.target;
    localStorage.setItem("userCountryCode", value);
    updateCombineData(name, value);
    updatePrevValue(name, value);
    setAccountMeta((prev) => ({ ...prev, [name]: value }));

    await updateUserMeta({
      name,
      value,
      skipPrevCheck: true,
      onSuccess: () => {
        dispatch(getUsersClientDetailsData({ id }));
        dispatch(getUsersCountryInfoData({ id }));
        dispatch(getUsersData({ id }));
      }
    });
  };

  const handleCustomerError = (name, value) => {
    const emojiRegex = /\p{Extended_Pictographic}/u;

    if (emojiRegex.test(value)) {
      setCustomerDetailsError((prev) => ({
        ...prev,
        [name]: Inputfieldvalidation.errorMsg.emojiNotAllowed
      }));
      return false;
    }

    if (name === "organizationId" && value?.length > 50) {
      setCustomerDetailsError((prev) => ({
        ...prev,
        organizationId: Inputfieldvalidation.errorMsg.companyNumberMaxLength
      }));
      return false;
    }

    if (name === "acn") {
      if (value !== "" && !NUMBER_REGEX.test(value)) {
        setCustomerDetailsError((prev) => ({
          ...prev,
          acn: Inputfieldvalidation.errorMsg.acnError
        }));
        return false;
      }
      if (value !== "" && value.length !== 9) {
        setCustomerDetailsError((prev) => ({
          ...prev,
          acn: Inputfieldvalidation.errorMsg.acnLength
        }));
      } else {
        setCustomerDetailsError((prev) => ({
          ...prev,
          acn: null
        }));
      }
    } else {
      setCustomerDetailsError((prev) => ({
        ...prev,
        [name]: null
      }));
    }

    return true;
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (!handleCustomerError(name, value)) {
      return;
    }
    if (name === "acn") {
      const digitsOnly = value.replace(/\D/g, "");
      setCombineData((prev) => ({ ...prev, acn: digitsOnly }));
    } else {
      setCombineData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSelectChange = async (event) => {
    const { name, value } = event.target;

    updateCombineData(name, value);

    if (name === "organisationType") {
      setOrganisationType(value);
    }

    if (name === "pricingIndustryId") {
      setPricingIndustryId(value);
    }

    await updateUserMeta({ name, value });
    updatePrevValue(name, value);
  };

  // For fecth Organization By Legal name
  const handlelegalInputBlur = useCallback(
    async (event) => {
      const { name, value } = event.target;

      const nzbnValue = combineData?.nzbn ?? "";
      const prevValue = prevValues?.[name] ?? "";

      if (prevValue === value) return;

      if (value && !nzbnValue) {
        setShowSelect(true);
        await getOrganization({ value });
      }

      try {
        await dispatch(updateProfile({ id, key: name, value })).unwrap();
      } catch {
        // handle catch here;
      }

      setPrevValues((prev) => ({ ...prev, [name]: value }));
    },
    [combineData?.nzbn, prevValues, id, dispatch, getOrganization]
  );

  const handleDownloadPDF = async () => {
    if (isLocked()) return;
    setIsProcessing(true);
    try {
      const response2 = await privateAxios.get(
        gethandleDownloadPDFURL(organizationID)
      );
      const pdfUrl = response2.data.data.downloadUrl;

      // Open the URL in a new tab
      window.open(pdfUrl, "_blank");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleSync = async () => {
    if (isLocked()) return;
    setIsProcessing(true);
    try {
      const dataToSend = getNZBN;
      const response = await privateAxios.post(
        getNZBNUserURL(getNZBN, id),
        dataToSend
      );
      dispatch(getUsersData({ id }));
      toast.success(response?.data?.message);
    } catch (error) {
      toast.error(
        error?.response?.data?.errors?.[0] || error?.response?.data?.message
      );
    } finally {
      setIsProcessing(false);
    }
  };

  const handlePutNZBNblur = async (event) => {
    const { name, value } = event.target;

    setCombineData((prevFormData) => {
      const updatedData = {
        ...prevFormData,
        [name]: value
      };
      return updatedData;
    });

    try {
      const nzbn = value;
      const dataToSend = {
        nzbn: sanitizeInput(value)
      };

      const response = await privateAxios.post(
        getNZBNUserURL(nzbn, id),
        dataToSend
      );

      if (response.status === 200) {
        dispatch(getUsersData({ id }));
        setShowSelect(false);
        setShowDownload(true);
      }

      toast.success(response?.data?.message);
    } catch (error) {
      toast.error(
        error?.response?.data?.errors?.[0] || error?.response?.data?.message
      );
    }
  };

  const handleInputBlur = async (event, isPost = false) => {
    const { name, value } = event.target;
    if (name === "tradingName" && customerDetailsError.tradingName !== null) {
      return;
    }
    const prevValue = prevValues[name] ?? "";
    if (prevValue === value) {
      return;
    }
    try {
      const { nzbn, acn, organisationType, organizationName } = combineData;
      const dataToSend = {
        nzbn: sanitizeInput(nzbn),
        acn: sanitizeInput(acn),
        organisationType,
        organizationName
      };

      if (!isPost) {
        await dispatch(
          updateProfile({ id, key: name, value: sanitizeInput(value) })
        ).unwrap();
      }

      if (name !== "organizationId") {
        await privateAxios.post(getNZBNUserURL(nzbn, id), dataToSend);
      }
      if (name !== "organizationId") {
        dispatch(getUsersData({ id }));
      }
    } catch (error) {
      showToast(
        error?.response?.data?.message || showToastType?.errorText,
        showToastType?.error
      );
    }

    // Update prevValues with the new value
    setPrevValues((prevValues) => ({
      ...prevValues,
      [name]: value
    }));
  };

  const handleAbnChange = async (event) => {
    const { name, value } = event.target;

    if (combineData[name] !== prevValues[name]) {
      try {
        const params = {
          id,
          key: name,
          value: sanitizeInput(value)
        };
        await dispatch(updateProfile(params)).unwrap();
        if (name !== "acn") {
          dispatch(getUsersData({ id }));
        }
      } catch (error) {
        showToast(
          error?.response?.data?.message ||
            error?.response?.data?.errors?.[0] ||
            showToastType?.errorText,
          showToastType?.error
        );
      }

      // Update prevValues with the new value
      setPrevValues((prevValues) => ({
        ...prevValues,
        [name]: value
      }));
    }
  };

  // for m10 account update function
  const handleAccountBlur = async (event) => {
    const { name, value } = event.target;
    const prevValue = prevValues[name] ?? "";

    if (prevValue === value) return;

    await updateUserMeta({ name, value });
  };

  const getDisplayValue = (value) => {
    return value !== null && value !== undefined && value !== ""
      ? value
      : "N/A";
  };

  const handleDropDownChange = async (event) => {
    const { name, value } = event.target;

    const normalizedValue = String(value).trim();

    setCombineData((prev) => ({
      ...prev,
      [name]: normalizedValue
    }));

    const prevValue = String(prevValues?.[name] ?? "").trim();
    const originalValue = String(combineData[name] ?? "").trim();

    if (normalizedValue === prevValue || normalizedValue === originalValue) {
      return;
    }

    try {
      const params = {
        id,
        key: name,
        value: normalizedValue
      };

      await dispatch(updateProfile(params)).unwrap();

      setPrevValues((prev) => ({
        ...prev,
        [name]: normalizedValue
      }));
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const tooltipsData = [
    {
      id: "tooltip-syncData",
      content: tooltipContent.syncData,
      place: "top"
    },
    {
      id: "tooltip-countryInfo",
      content: tooltips.countryInfo,
      place: "top"
    },
    {
      id: "tooltip-industry",
      place: "top"
    },
    {
      id: "customer-download-PDF",
      content: tooltipContent.download,
      place: "top"
    },
    {
      id: "customer-syncData",
      content: tooltipContent.syncData,
      place: "top"
    }
  ];

  return (
    <ErrorBoundary fallback={<ComponentViewFallback />}>
      <>
        <div className={styles.titleArea}>
          <h5>{customerTab?.details.mainTitle}</h5>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle} border-bottom`}>
                <h5>{customerTab?.details.accSoftware}</h5>
              </div>
              <div className="d-flex">
                <p className="calcWidth">
                  {accSoftwareConct === "Not connected"
                    ? manualUpdate
                    : accSoftwareConct}
                </p>
                {accSoftwareIsConnct && (
                  <button
                    className={`${styles.btnPrimary} added-icon`}
                    data-tooltip-id="tooltip-syncData"
                    data-tooltip-content={tooltipContent.syncData}
                    onClick={handleRefreshSoftwareConnect}
                    disabled={isProcessing}
                  >
                    <TbRefresh />
                  </button>
                )}
              </div>
              <div className={styles.linkwrap}>
                {showDetails && (
                  <ul className={styles.linkAllAccount}>
                    <li>
                      <strong>{customerTab?.details.liabilityAccount}</strong>
                      <br />
                      <span>
                        {getDisplayValue(customerDetails?.accounts?.liability)}
                      </span>
                    </li>
                    <li>
                      <strong>{customerTab?.details.expenseAccount}</strong>
                      <br />
                      <span>
                        {getDisplayValue(customerDetails?.accounts?.expense)}
                      </span>
                    </li>
                    <li>
                      <strong>{customerTab?.details.bankAccount}</strong>
                      <br />
                      <span>
                        {getDisplayValue(customerDetails?.accounts?.bank)}
                      </span>
                    </li>
                  </ul>
                )}
                <button className={styles.showDetails} onClick={toggleDetails}>
                  {showDetails
                    ? customerTab?.details.lessDetails
                    : customerTab?.details.moreDetails}
                </button>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.details.country}</h5>
              </div>
              <div
                className={`${styles.inputWithButton} d-flex align-items-center`}
              >
                <select
                  className={`${styles.selectdropdown} withoutselecticon`}
                  name="primaryCountry"
                  value={accountMeta.primaryCountry ?? ""}
                  onChange={handleCountryChange}
                >
                  {countries?.map((country, index) => (
                    <option key={index} value={country.value}>
                      {country.name}
                    </option>
                  ))}
                </select>
                <span className={`${styles.btnPrimary} info-icon added-icon`}>
                  <input
                    type="button"
                    onClick={toggleCountryAdd}
                    data-tooltip-id="tooltip-countryInfo"
                    data-tooltip-content={tooltips.countryInfo}
                  />
                </span>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>
                  {accountMeta.primaryCountry === COUNTRY_CODE_AU
                    ? customerTab?.details.abn
                    : customerTab?.details.nzbn}
                </h5>
              </div>
              <div className="inputtextfield">
                {accountMeta.primaryCountry === COUNTRY_CODE_AU ? (
                  <CommonInput
                    type="text"
                    name="abn"
                    className={styles.textfield}
                    value={combineData.abn ?? ""}
                    onChange={handleInputChange}
                    onBlur={(event) => handleAbnChange(event, combineData.abn)}
                  />
                ) : (
                  <div className="d-flex">
                    {showSelect === true ? (
                      <select
                        type="text"
                        name="nzbn"
                        className={styles.textfield}
                        value={combineData?.nzbn || ""}
                        onChange={(event) =>
                          handlePutNZBNblur(event, combineData?.nzbn)
                        }
                      >
                        <option key="0">
                          {customerTab?.details.selectNzbn}
                        </option>
                        {showSelectData &&
                          showSelectData?.map((org, index) => (
                            <option value={org?.nzbn} key={index + 1}>
                              {org?.entityName}
                            </option>
                          ))}
                      </select>
                    ) : (
                      <CommonInput
                        type="text"
                        name="nzbn"
                        className={styles.textfield}
                        value={combineData?.nzbn || ""}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                      />
                    )}
                    {showDownload &&
                    customerDetails?.customerDetails?.businessDetails?.nzbn ? (
                      <ul
                        className={`${styles.btngroupwrap} d-flex justify-content-end align-items-center list-no-padding`}
                      >
                        <li>
                          <button
                            className={`${styles.btnPrimary} added-icon`}
                            data-tooltip-id="customer-download-PDF"
                            data-tooltip-content={tooltipContent.download}
                            onClick={handleDownloadPDF}
                            disabled={isProcessing}
                          >
                            <FaLongArrowAltDown />
                          </button>
                        </li>
                        <li>
                          <button
                            className={`${styles.btnPrimary} added-icon`}
                            data-tooltip-id="customer-syncData"
                            data-tooltip-content={tooltipContent.syncData}
                            onClick={handleSync}
                            disabled={isProcessing}
                          >
                            <TbRefresh />
                          </button>
                        </li>
                      </ul>
                    ) : null}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.details.orgType}</h5>
              </div>
              <select
                className={`${styles.selectdropdown}`}
                name="organisationType"
                value={organisationType ?? ""}
                onChange={handleSelectChange}
              >
                {org_types?.map((orgtype, index) => (
                  <option key={index} value={orgtype.value}>
                    {orgtype.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.details.accType}</h5>
              </div>
              <select
                className={`${styles.selectdropdown}`}
                name="accountType"
                value={combineData.accountType ?? ""}
                onChange={handleDropDownChange}
              >
                {account_type?.map((typedata, index) => (
                  <option key={index} value={index + 1}>
                    {typedata.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>
                  {accountMeta.primaryCountry === COUNTRY_CODE_AU
                    ? customerTab?.details.acn
                    : customerTab?.details.companyNo}
                </h5>
              </div>

              <div className="inputtextfield">
                {accountMeta.primaryCountry === COUNTRY_CODE_AU ? (
                  <>
                    <CommonInput
                      type="text"
                      name="acn"
                      className={styles.textfield}
                      placeholder=""
                      value={combineData.acn || ""}
                      onChange={handleInputChange}
                      onBlur={handleAbnChange}
                      maxLength={9}
                    />
                    {customerDetailsError.acn && (
                      <span className={styles.errorText}>
                        {customerDetailsError.acn}
                      </span>
                    )}
                  </>
                ) : (
                  <>
                    <CommonInput
                      type="text"
                      name="organizationId"
                      className={styles.textfield}
                      value={combineData.organizationId ?? ""}
                      onChange={handleInputChange}
                      onBlur={handleInputBlur}
                    />
                    {customerDetailsError.organizationId && (
                      <span className={styles.errorText}>
                        {customerDetailsError.organizationId}
                      </span>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.details.legalName}</h5>
              </div>
              <div className="inputtextfield">
                <CommonInput
                  type="text"
                  name="organizationName"
                  className={styles.textfield}
                  value={combineData.organizationName ?? ""}
                  onChange={handleInputChange}
                  onBlur={handlelegalInputBlur}
                />
                {customerDetailsError.organizationName && (
                  <span className={styles.errorText}>
                    {customerDetailsError.organizationName}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle} border-bottom`}>
                <h5>{customerTab?.details.companyStatus}</h5>
              </div>
              <p>{combineData.organizationStatus}</p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.details.tradingName}</h5>
              </div>
              <div className="inputtextfield">
                <CommonInput
                  type="text"
                  name="tradingName"
                  className={styles.textfield}
                  value={combineData.tradingName ?? ""}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                />
                {customerDetailsError.tradingName && (
                  <span className={styles.errorText}>
                    {customerDetailsError.tradingName}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.details.taxNumber}</h5>
              </div>
              <div className="inputtextfield">
                <CommonInput
                  type="text"
                  name="taxNumber"
                  className={styles.textfield}
                  value={combineData.taxNumber ?? ""}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.details.industry}</h5>
              </div>
              <div
                className={`${styles.inputWithButton} d-flex align-items-center`}
              >
                <select
                  className={`${styles.selectdropdown} withoutselecticon`}
                  onChange={handleSelectChange}
                  name="pricingIndustryId"
                  value={pricingIndustryId || ""}
                >
                  <option value="">
                    {EditReffPartner?.editReffModal.choose}
                  </option>
                  {industryType.length === 0 ? (
                    <option value="">{customerTab?.details.noIndustry}</option>
                  ) : (
                    industryType?.map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.industryName?.toLowerCase() === "other"
                          ? bankDetls?.othersSpecify
                          : data.industryName}
                      </option>
                    ))
                  )}
                </select>
                <span className={`${styles.btnPrimary} info-icon added-icon`}>
                  <input
                    type="button"
                    onClick={toggleAddSuccessfullModal}
                    data-tooltip-id="tooltip-industry"
                    data-tooltip-content={tooltips.industryInfo}
                  />
                </span>
              </div>
            </div>
          </div>

          {Number(pricingIndustryId) === 6 && (
            <div className="col-12 col-sm-6 col-md-4 mb-3">
              <div className="blog-input-wrap">
                <div className={`${styles.labelTitle}`}>
                  <h5>{customerTab?.details.industryDetails}</h5>
                </div>
                <div className="inputtextfield">
                  <CommonInput
                    type="text"
                    className={styles.textfield}
                    placeholder={customerTab?.details.industryDetails}
                    name="industryDetails"
                    value={combineData.industryDetails ?? ""}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle} border-bottom`}>
                <h5>{customerTab?.details.age}</h5>
              </div>
              <p>{combineData.organizationAge}</p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.details.industryClassfication}</h5>
              </div>
              <select
                className={`${styles.selectdropdown} dropdown-icon-none`}
                name="industryClassification"
                value={combineData.industryClassification ?? ""}
                onChange={handleSelectChange}
              >
                <option value="">
                  {EditReffPartner?.editReffModal.choose}
                </option>
                {industryCategory.length === 0 ? (
                  <option value="">{customerTab?.details.unbleToFetch}</option>
                ) : (
                  industryCategory?.map((data) => (
                    <option key={data.id} value={data.id}>
                      {data.userIndustryCategoryName}
                    </option>
                  ))
                )}
              </select>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.details.m10Acc}</h5>
              </div>
              <div className="inputtextfield">
                <CommonInput
                  type="text"
                  name="m10CCBAccount"
                  className={styles.textfield}
                  value={accountMeta.m10CCBAccount ?? ""}
                  onChange={(e) =>
                    setAccountMeta({
                      ...accountMeta,
                      m10CCBAccount: e.target.value
                    })
                  }
                  onBlur={handleAccountBlur}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-8 mb-3" />

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <div className="blog-input-wrap">
              <div className={`${styles.labelTitle}`}>
                <h5>{customerTab?.details.m10Local}</h5>
              </div>
              <div className="inputtextfield">
                <CommonInput
                  type="text"
                  name="m10LocalAccount"
                  className={styles.textfield}
                  value={accountMeta.m10LocalAccount ?? ""}
                  onChange={(e) =>
                    setAccountMeta({
                      ...accountMeta,
                      m10LocalAccount: e.target.value
                    })
                  }
                  onBlur={handleAccountBlur}
                />
              </div>
            </div>
          </div>
        </div>
        <CountryinfoModal
          isOpen={addCountryMoadal}
          toggle={toggleCountryAdd}
          countryInformation={countryInformation}
        />
        <SuccessfullModal
          isOpen={addSuccessfullModal}
          toggle={toggleAddSuccessfullModal}
          title={customerTab?.details?.industry}
          message={customerTab?.details?.infoFound}
        />
        {tooltipsData.map(({ id, content, place }) => (
          <ReactTooltip
            key={id}
            className="tooltipcustom"
            id={id}
            place={place || "top"}
            content={content}
          />
        ))}
      </>
    </ErrorBoundary>
  );
};

CustomerDetails.propTypes = {
  accSoftwareIsConnct: PropTypes.bool,
  accSoftwareConct: PropTypes.string,
  onRefreshSoftware: PropTypes.func
};

export default CustomerDetails;
